import * as React from "react";
import {Component} from "react";
import styles from "../styles/wizards/EditProductAttributeGroupFieldWizard.scss";
import autobind from "autobind-decorator";
import ProductAttributeEditIcon from "../assets/images/product-attribute-edit-60x60.svg";
import {__, mapStateToProps, setTableParams, toBoolean, validateForm} from "../core/utils";
import AddProductAttributeGroupFieldForm
	from "../forms/add_product_attribute_group_field_wizard/AddProductAttributeGroupFieldForm";
import {setNotification} from "../redux/actions/general/notification";
import {
	addProductAttributeGroupField,
	readProduct,
	updateProductAttributeGroupField
} from "../redux/actions/table/products";
import EditProductAttributeGroupFieldForm
	from "../forms/edit_product_attribute_group_field_form/EditProductAttributeGroupFieldForm";
import * as _ from "lodash";
import {subscribe} from "react-contextual";
import Localization from "../helpers/Localization";

@mapStateToProps(state => ({
	field_id: _.get(state, 'table.products.edit_product_attribute_group_field_wizard'),
	flyout: state.table.products.flyout
}))
@subscribe(Localization, "localization")
class EditProductAttributeGroupFieldWizard extends Component {
	@autobind
	_handleSubmit(formData) {
		formData = {
			...formData,
			custom_attribute: _.get(formData, 'custom_attribute', false) ? 1 : 0,
		};

		return validateForm(
			updateProductAttributeGroupField(this.props.field_id, formData).then(() => readProduct(this.props.flyout.id).then(({response}) => {
				setNotification(__('products.all-products.flyout.product-attribute-has-been-updated'));

				setTableParams('products', {
					flyout: response.data
				});

				this.props.onClose();
			}))
		);
	}

	render() {
		const {flyout, field_id} = this.props;

		let attribute = _.find(_.flatten(_.map(flyout.attribute_groups, 'attributes')), ['id', field_id]);

		const type = attribute.template_field_id ? _.get(this.props.localization.product_attribute_fields, [attribute.template_field_id, 'type']) : attribute.type;

		let initialValues = {
			custom_attribute: !attribute.template_field_id,
			template_field_id: attribute.template_field_id,
			unit_id: (type == 'numeric' || type == 'dropdown_numeric' || type == 'dropdown_numeric_multiple' || type == 'range' || type == 'range_selectable') ? attribute.unit_id : undefined,
			type
		};

		if(!attribute.template_field_id) {
			initialValues['label'] = attribute.label;
		}

		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>{__('products.all-products.flyout.edit-product-attribute')}</span>
						<span>{__('products.all-products.flyout.edit-attribute-your-product-attribute-group')}</span>
					</div>
					<div className={styles.right}>
						<ProductAttributeEditIcon />
					</div>
				</div>
				<div className={styles.body}>
					<EditProductAttributeGroupFieldForm onSubmit={this._handleSubmit} initialValues={initialValues} />
				</div>
			</>
		);
	}
}

export default EditProductAttributeGroupFieldWizard;
